import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`
